@if ({}; as STATE) {
  <article class="card-details">
    <button
      type="button"
      class="card-details__close-button"
      mat-dialog-close
      [matTooltip]="'Fermer'"
      aria-label="Fermer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z"
        />
      </svg>
    </button>
    <section>
      <hgroup class="card-details__header">
        <div>
          <h2>{{ channels()?.name }}</h2>
          <p>Créée le : {{ channels()?.createdAt | date: 'dd/MM/yyyy' }}</p>
        </div>
        <span>
          <img
            [ngSrc]="channels()?.logoUrl || '/assets/images/broken-image.svg'"
            [alt]="channels()?.name"
            [height]="40"
            [width]="40"
            class="mat-table-container__brand-logo"
          />
        </span>
      </hgroup>
      <div class="card-details__table__wrapper">
        <table>
          <tbody>
            <tr>
              <td>Pays</td>
              <td>
                {{ (channels()?.country | isoToCountry) || '-' }}
              </td>
            </tr>
            <tr>
              <td>Type de média</td>
              <td>
                {{ channels()?.mediaType | mediaType }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </article>
}
